/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

import { FlexCol, FlexRow } from 'sarsaparilla';
import {
    AnchorPageWithSidebarLayout,
    AnchorPageSection,
} from 'shared-ui/components/AnchorPageWithSidebarLayout';
import { InventoryReviewsSection } from 'ui-rating-review';
import List from './List';
import PassTypes from './PassTypes';

export default function Content({ facility, passTypes, rating }) {
    const ntk = orderBy(
        get(facility, 'contents.need_to_know', []).filter(
            (item) => !isNil(item.paragraphs)
        ),
        ['title'],
        ['desc', 'asc']
    );
    const RenderIf = (val) => !isEmpty(val) && !isNil(val);
    const numberOfRatings = get(rating, 'number_of_ratings', 1);
    const renderRatingIf = numberOfRatings > 0 && !isEmpty(facility);

    return (
        <div className="ap-content">
            <FlexRow>
                <FlexCol lg={12}>
                    <AnchorPageWithSidebarLayout>
                        <AnchorPageSection appareance="h5-normal" heading="Options">
                            <PassTypes passTypes={passTypes} />
                        </AnchorPageSection>
                        {RenderIf(ntk) && (
                            <AnchorPageSection
                                appareance="h5-normal"
                                heading="Need to Know"
                            >
                                <List content={ntk} />
                            </AnchorPageSection>
                        )}
                        {renderRatingIf && !isEmpty(facility.id) && (
                            <AnchorPageSection
                                appareance="h5-normal"
                                heading="Rating and Reviews"
                            >
                                <InventoryReviewsSection
                                    locationId={facility?.id}
                                    locationType="Activity Pass"
                                    noHeading={true}
                                />
                            </AnchorPageSection>
                        )}
                    </AnchorPageWithSidebarLayout>
                </FlexCol>
            </FlexRow>
        </div>
    );
}

Content.propTypes = {
    facility: PropTypes.object,
    rating: PropTypes.object,
    passTypes: PropTypes.any,
};
